// extracted by mini-css-extract-plugin
export default {"container":"FormV1_container__sLuGm","titleContainer":"FormV1_titleContainer__wfLUb","icon":"FormV1_icon__fF7vp","formContainer":"FormV1_formContainer__5wVE9"};